export const SEARCH_DEBOUNCE_TIME = 500;

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
